import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import Status from '../../../../constants/status-codes';
import InfoBox from '../../../../components/InfoBox/InfoBoxError';
import NOB from '../../../../constants/language-strings';
import SimpleButton from '../../../../components/Buttons/SimpleButton/SimpleButton';
import { TECHNICIAN } from '../../../Authentication/constants';
import styled from 'styled-components';
import { useChangeWorkOrderStatus } from 'modules/Workorder/api/use-change-workorder-status';
const WorkOrderButtonContainer = styled.div `
  margin-bottom: 20px;

  @media (min-width: 1024px) {
    margin-top: auto;
  }
`;
export const ChangeStatusButton = ({ workOrder, isFetching }) => {
    const workOrderList = useSelector((state) => state.workOrders);
    const isTechnician = useSelector((state) => state.authentication.role === TECHNICIAN);
    const { changeWorkOrderStatus, isChangeStatusLoading, changeStatusError } = useChangeWorkOrderStatus();
    const handlePrimaryClick = () => {
        changeWorkOrderStatus({
            workOrderId: workOrder.workOrderId,
            currentStatus: workOrder.status,
        });
    };
    const canChangeStatus = workOrderList.startedWorkOrder.includes(workOrder.workOrderId) ||
        !workOrderList.startedWorkOrder.length ||
        !isTechnician;
    const buttonText = Status.ALLOCATED.includes(workOrder.status)
        ? NOB.WORKORDER_BUTTON.DRIVE
        : NOB.WORKORDER_BUTTON.WORK;
    const isDisabled = !canChangeStatus;
    return (_jsxs(WorkOrderButtonContainer, { children: [!Status.COMPLETE_ARRAY.includes(workOrder.status) &&
                !Status.INCOMPLETE_ARRAY.includes(workOrder.status) && (_jsx(SimpleButton, { title: buttonText, disabled: isDisabled, isFetching: isChangeStatusLoading ||
                    isFetching ||
                    workOrderList.isFetching, onClick: handlePrimaryClick })), (isDisabled || changeStatusError) && (_jsx(InfoBox, { firstInfoBoxLine: isDisabled
                    ? NOB.WORKORDER_BUTTON.UNABLE_TO_START
                    : changeStatusError, background: false }))] }));
};
